import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { IVotingQuestions } from "../../models/VotingQuestions";
import ShowYourAnswers from "./ShowYourAnswers";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILogin } from "../../models/Login";

import { JVRadioBtn } from "../../shared/JVRadioBtn";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";

interface Iprops {
    singleData: IVotingQuestions
    open: boolean,
    toast: any,
    isAdmin : boolean,
    hideDialog: () => void,
    loadTableData: () => void,
    isActive : string | boolean
}

// const schema = yup.object({
//     submitted_Answer: yup.string()
// })


export const Answer = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IVotingQuestions>, loading: boolean });
    const [data, setData] = useState<IVotingQuestions[]>([]);
    const [loading, setLoading] = useState(false);

    // const { control, handleSubmit } = useForm<IVotingQuestions>({
    //     resolver: yupResolver(schema),
    //     defaultValues: props.singleData,
    //     shouldFocusError: false
    // });

    // useEffect(() => {
    //     if (props.singleData) loadTableData()
    // }, [props.singleData]);

    useEffect(() => {
        
        if (props.singleData.voting_Que_ID) loadData();
        loadAnswers();

    }, [props.singleData.voting_Que_ID]);

    // useEffect(()=>{
    // });

    const loadAnswers = async()=>{
            
        const response = await Fetch("Voting_Questions/listAnswer", 'GET', null, `que_id=${props.singleData.voting_Que_ID}`, props.toast);
        
        if(response){
            const respData = await response.json();
            let datas = respData.map((el:any)=>{
                return {
                    userName: el.userName,
                    user_Answer: el.submitted_Answer === 1 ? "Yes" : "No",
                    submitted_Answer: el.submitted_Date.split("T")[0],
                }
            });
            
            setTableData({ tableData: datas, loading: false });
        }
    };

    const loadData = async () => {
        setLoading(true);
        
        const response = await Fetch("Voting_Questions/queDetails", 'GET', null, `que_id=${props.singleData.voting_Que_ID}`, props.toast)
        if (response)
        
        {
            let data: IVotingQuestions = await response.json();

            
            // console.log("datas",data);
            
            if(data.submitted_Answer === 1){
                data.submitted_Answer = "Yes";
            } else if(data.submitted_Answer === 0){
                data.submitted_Answer = "No";
            } else {
                data.submitted_Answer = "";
            }
            data.submitted_Date = data.submitted_Date?.split("T")[0];

            let tableData: IVotingQuestions[] =  [data];

            // tableData.submitted_Answer= 

            // console.log(typeof data);
            // console.log("tableData",tableData);

            setData(tableData);

            // setData(data);

            setLoading(false);

        } else setLoading(false)
    }

    // const loadTableData = async () => {
    //     setTableData({ tableData: tableData.tableData, loading: true });
    //     const response = await Fetch("Voting_Questions", "GET", null, '', props.toast);
    //     if (response) {
    //         const data: Array<IVotingQuestions> = await response.json();
    //         setTableData({ tableData: data, loading: false });
    //     } else setTableData({ tableData: tableData.tableData, loading: false });
    // }

    const onHide = () => {
        props.hideDialog();
        setTableData({ tableData: [], loading: false });
    }

    // function onSubmit(data: IVotingQuestions) {
    //     saveToDB(data);
    // }

    const setLoadings=()=>{
        loadData();
        props.loadTableData();
    }

    // const saveToDB = async (body: IVotingQuestions) => {
    //     setLoading(true);
        
    //     const method = props.singleData.voting_Que_ID ? 'PUT' : 'POST';
    //     const message = props.singleData.question = 'Submitted';
    //     const response = await Fetch("Voting_Questions/queDetails", method, body, null, props.toast);

    //     if (response) {
    //         props.hideDialog();
    //         props.toast.current.show({ severity: 'success', summary: 'Successful', detail: message, life: 3000 });
    //     }
       
    // }

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFromat = loginObj.date_Format;
    return (

        <Dialog visible={props.open} style={{ width: '80vw' }} header="Voting Answer" className="p-fluid" onHide={onHide}>
            
            <ShowYourAnswers props={props} setLoadings={setLoadings}/>

            <DataTable className="mt-auto" style={{ border:'4px solid rgba(105,105,105,0.17)', borderTopWidth: '0' }}
                size="small"
                value={data}
                loading={loading}

            >
                <Column field="question" header="Question"  />
                {/* <Column field="expiry_Date" header="Voting Closed On" /> */}
                  <Column field="expiry_Date" header="Voting Closed On" body={(rowData: any) => safeFormatDate(rowData.expiry_Date, 'dd/MM/yyyy', DateFromat)} />
                {/* <Column field="submitted_Date" header="Answer Date" /> */}
                <Column field="submitted_Date" header="Answer Date" body={(rowData: any) =>safeFormatDate( rowData.submitted_Date, "dd/MM/yyyy", DateFromat )}/>
                <Column field="submitted_Answer" header="Your Answer" />
                <Column field="total_Yes" header="Yes" />
                <Column field="total_No" header="No" />
                <Column field="yes_Per" header="Yes%" />
                <Column field="no_Per" header="No%" />
                <Column field="total_Answer" header="Total Answer" />


            </DataTable>
            {props.isAdmin && <DataTable className="mt-3" style={{ border: '4px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="userName" header="Name" />
                <Column field="user_Answer" header="Answer" />
                {/* <Column field="submitted_Answer" header="Date" /> */}
                <Column field="submitted_Answer" header="Date" body={(rowData: any) => safeFormatDate(rowData.submitted_Answer, 'dd/MM/yyyy', DateFromat)} />
            </DataTable>}
        </Dialog>
       
    );
}
